import React, { useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import * as THREE from "three"
import leftWall from "../../../Assets/Walls/LeftWall/LeftWall.glb"
import aoTex from "../../../Assets/Walls/RightWall/ao.jpg"
import lightTex from "../../../Assets/Walls/RightWall/light.jpg"
import emission from "../../../Assets/Walls/LeftWall/Side_Walls_emisionmaop.jpg"
import emissiveTex from "../../../Assets/Walls/RightWall/emissive.jpg"

export default function Model({size, position}) {
  const group = useRef()
  const ref1 = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const { nodes, materials } = useGLTF(leftWall)

  const refArr = [ref1, ref2, ref3]

  const [lightMap, aoMap, emissionMap, lightMap1, aoMap1, emissionMap1] = useTexture([lightTex, aoTex, emissiveTex, lightTex, aoTex, emission])

  lightMap.flipY = lightMap1.flipY = false
  aoMap.flipY = aoMap1.flipY = false
  emissionMap.flipY = false
  lightMap.encoding = lightMap1.encoding = THREE.RGBFormat
  aoMap.encoding = aoMap1.encoding = THREE.RGBFormat
  emissionMap.encoding = emissionMap1.encoding = THREE.RGBFormat
  // lightMap1.wrapS = lightMap1.wrapT= THREE.RepeatWrapping
  lightMap.anisotropy = lightMap1.anisotropy = aoMap.anisotropy = aoMap1.anisotropy = emissionMap.anisotropy = emissionMap1.anisotropy = 16

  const sideWall = React.useMemo(() => new THREE.MeshPhongMaterial({
    aoMap : aoMap,
    aoMapIntensity : 0.1,
    map: lightMap,
    color: "#555555",
    specular: "#3A3A3A",
    shininess : 32,
    emissiveMap : emissionMap,
    emissive : "#ffffff",
    emissiveIntensity : 0.5,
    lightMap : lightMap,
    lightMapIntensity: -1,
    // side : THREE.DoubleSide,
  }), [])
  
  const wallTile = React.useMemo(() => new THREE.MeshPhongMaterial({
    map: lightMap1,
    color : "#333333",
    specular : "#3A3A3A",
    shininess : 32,
    emissive : "#000000",
    // visible : false
    side : THREE.DoubleSide,
  }), [])

  const lightMat = React.useMemo(() => new THREE.MeshPhongMaterial({
    color : "#ffffff",
    specular : "#3A3A3A",
    shininess : 32,
    emissive : "#ffffff",
    // visible : false
    side : THREE.DoubleSide,
}), [])

    const dummy = React.useMemo(() => new THREE.Object3D(), [])
    const numberOfWalls = React.useMemo(() => Math.round((size+50)/9.144) + 2, [size])

  React.useLayoutEffect(() => {

    const uvs = ref1.current.geometry.attributes.uv.array;
    ref1.current.geometry.setAttribute( 'uv2', new THREE.BufferAttribute( uvs, 2 ) );


      const arraySize = numberOfWalls
      Array(arraySize).fill(null).map((b, index) => {
          dummy.position.set(((((size+50)/2)*33.33)-3.048*100*index), 0, 0)
          dummy.updateMatrix()
          refArr.map(r => {
              r.current.setMatrixAt(index, dummy.matrix)
            })
      })

      refArr.map(r => {
          r.current.instanceMatrix.needsUpdate = true
        })
  }, [])


  return (
    <group ref={group} position={position} scale={[1,1,1]} dispose={null}>
      <group position={[0.24, 0, 0]} rotation={[Math.PI / 2, 0, 0]} scale={[0.03, 0.03, 0.03]}>
        <instancedMesh 
            ref={ref1}
            args ={[nodes.Mesh001.geometry,null, numberOfWalls]}
            material={sideWall}/>
        <instancedMesh 
            ref={ref2}
            args ={[nodes.Mesh001_1.geometry,null, numberOfWalls]}
            material={lightMat} />
        <instancedMesh 
            ref={ref3}
            args ={[nodes.Mesh001_2.geometry,null, numberOfWalls]}
            material={wallTile}/>
      </group>
    </group>
  )
}

useGLTF.preload(leftWall)
